<template>
    <b-table
        class="base-table"
        :fields="tableColumns"
        :items="items"
        :busy="loading"
        :primary-key="primaryKey"
        :sticky-header="stickyHeader"
        :empty-text="emptyText"
        show-empty
        borderless
        fixed
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template #table-busy>
            <div class="base-table-loading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
        </template>

        <template #empty>
            <p class="base-table-empty">{{ emptyText }}</p>
        </template>

        <template v-for="(_, name) in $scopedSlots" #[name]="scope">
            <slot :name="name" v-bind="scope"></slot>
        </template>
    </b-table>
</template>

<script>
export default {
    name:         'base-table',
    inheritAttrs: false,
    props:        {
        columns: {
            type:     Array,
            required: true
        },
        items: {
            type:    Array,
            default: () => []
        },
        loading: {
            type:    Boolean,
            default: false
        },
        emptyText: {
            type:    String,
            default: ''
        },
        primaryKey: {
            type:    String,
            default: 'id'
        },
        fill: {
            type:    Boolean,
            default: false
        },
        fillOffset: {
            type:    Number,
            default: 40
        }
    },

    data () {
        return { fillHeight: null };
    },

    computed: {
        tableColumns () {
            return this.columns.map((column) => {
                const width = typeof column === 'object' && column.thStyle && column.thStyle.width;

                return width ? { ...column, tdAttr: { style: `width: ${width}` } } : column;
            });
        },

        stickyHeader () {
            return this.fill && this.fillHeight ? `${this.fillHeight}px` : false;
        }
    },

    watch: {
        items () {
            this.measure();
        },

        loading () {
            this.measure();
        }
    },

    mounted () {
        if (this.fill) {
            this.measure();
            window.addEventListener('resize', this.measure);
        }
    },

    beforeDestroy () {
        window.removeEventListener('resize', this.measure);
    },

    methods: {
        measure () {
            if (!this.fill) {
                return;
            }

            this.$nextTick(() => {
                const minHeight = 200;
                const top       = this.$el.getBoundingClientRect().top;

                this.fillHeight = Math.max(minHeight, Math.round(window.innerHeight - top - this.fillOffset));
            });
        }
    }
};
</script>
